<template>
  <b-container fluid>
    <!-- STEP 1 -->
    <div v-if="step == 1">
      <b-row>
        <b-col class="header">
          <strong>Seus Dados</strong>
          <br />
          <small>Esses são os unicos dados que salvaremos, apenas por questões estatísticas! Fique a vontade se nao quiser preenchê-los</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="input-group-1" label="Qual seu Nome?" label-for="input-1">
            <b-form-input id="input-1" v-model="name" required placeholder="Nome Completo"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="input-group-2" label="Qual sua empresa?" label-for="input-2">
            <b-form-input id="input-2" v-model="company" required placeholder="Nome da Empresa"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="options">
          <div></div>
          <b-button type="submit" variant="primary" v-on:click="nextStep">Próxima</b-button>
        </b-col>
      </b-row>
    </div>

    <!-- STEP 2 -->
    <div v-if="step == 2">
      <b-row>
        <b-col class="header">
          <strong>Notas Fiscais</strong>
          <br />
          <small>Informe o valor total de notas fiscais emitidas para efetuarmos os cálculos!</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="input-group-1" label="Qual o Valor?" label-for="input-1">
            <money
              id="input-1"
              class="form-control"
              v-model="value"
              required
              placeholder="R$ 9.9999,99"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="options">
          <b-button type="reset" variant="danger" v-on:click="prevStep">Voltar</b-button>
          <b-button type="submit" variant="primary" v-on:click="nextStep">Próxima</b-button>
        </b-col>
      </b-row>
    </div>

    <!-- STEP 3 -->
    <div v-if="step == 3">
      <b-row>
        <b-col class="header" style="margin-bottom: 20px">
          <strong>Suas Receitas</strong>
          <money
            v-model="receitas"
            disabled
            style="border: 0; background-color: transparent; width: fit-content"
          ></money>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-row>
            <b-col cols="12">
              <money class="finalValue" v-model="proLabore" disabled></money>
            </b-col>
            <b-col cols="12">
              <strong class="itemTitle">
                Pró-Labore
                <br />Declarar
              </strong>
            </b-col>
            <b-col cols="12">
              <small class="itemSubtitle">(29% dos rendimentos)</small>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <b-row>
            <b-col cols="12">
              <money class="finalValue" v-model="retirar" disabled></money>
            </b-col>
            <b-col cols="12">
              <strong class="itemTitle">
                Pró-Labore
                <br />Retirar
              </strong>
            </b-col>
            <b-col cols="12">
              <small class="itemSubtitle">(pró-labore menos INSS)</small>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4">
          <b-row>
            <b-col cols="12">
              <money class="finalValue" v-model="distribuicao" disabled></money>
            </b-col>
            <b-col cols="12">
              <strong class="itemTitle">
                Distribuição
                <br />de lucros
              </strong>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr style="margin: 25px" />
      <b-row>
        <b-col class="header" style="margin-bottom: 20px">
          <strong>Suas Despesas</strong>
          <money
            v-model="impostos"
            disabled
            style="border: 0; background-color: transparent; width: fit-content"
          ></money>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col cols="12">
              <money class="finalValue" v-model="inss" disabled></money>
            </b-col>
            <b-col cols="12">
              <strong class="itemTitle">INSS</strong>
            </b-col>
            <b-col cols="12">
              <small class="itemSubtitle">(11% dos pró-labore)</small>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col cols="12">
              <money class="finalValue" v-model="aliquota"></money>
            </b-col>
            <b-col cols="12">
              <strong class="itemTitle">Aliquota</strong>
            </b-col>
            <b-col cols="12">
              <small class="itemSubtitle">(6% dos rendimentos)</small>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="options">
          <b-button type="reset" variant="danger" v-on:click="prevStep">Voltar</b-button>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      company: "",
      value: 0,
      step: 1,

      salarioMinimo: 1045,
      proLabore: 0,
      retirar: 0,
      inss: 0,
      aliquota: 0,
      impostos: 0,
      distribuicao: 0,
      receitas: 0
    };
  },

  mounted: function() {
    window._paq.push();

    if (localStorage.name) {
      this.name = localStorage.name;
    }
    if (localStorage.company) {
      this.company = localStorage.company;
    }

    if (this.name && this.company) {
      window._paq.push(["setUserId", this.name + " | " + this.company]);
    }
  },
  methods: {
    prevStep: function() {
      this.step--;
    },
    nextStep: function() {
      if (this.name) {
        localStorage.name = this.name;
      }
      if (this.company) {
        localStorage.company = this.company;
      }

      if (this.value < 1111.7 && this.step == 2) {
        alert("O Valor do precisa ser maior que R$ 1.111,70");
        this.step = 2;
      } else {
        if (this.value) {
          this.proLabore = (this.value * 29) / 100;

          if (this.proLabore < this.salarioMinimo) {
            this.proLabore = this.salarioMinimo;
          }

          this.inss = (this.proLabore * 11) / 100;
          this.aliquota = (this.value * 6) / 100;
          this.retirar = this.proLabore - this.inss;
          this.impostos = this.inss + this.aliquota;
          this.distribuicao = this.value - (this.retirar + this.impostos);
          this.receitas = this.distribuicao + this.retirar;
        }

        this.step++;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  margin-bottom: 50px;

  strong {
    margin-top: 20px;
    font-size: 30px;
    color: #1d2434;
  }
  small {
    margin-top: 10px;
    width: 80%;
    text-align: justify;
    color: #ffc400;
  }
}

.options {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.btn-primary {
  background-color: #1d2434;
}

.finalValue {
  color: #ffc400;
  width: 100%;
  border: none;
  font-weight: bold;
  font-size: 22px;
  background-color: transparent;
}

.itemTitle {
  color: #1d2434;
  font-size: 15px;
  text-align: center;
}

.itemSubtitle {
  color: #1d2434;
  font-size: 10px;
  text-align: center;
}
</style>